<app-page-header title="Home" active_item="Transferir Saldo" titleLink="/reports"></app-page-header>
<div class="loading-transfer-balance" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>{{ 'common.balanceTransfer' | translate }}</h5>
<div class="row">
<div class="col-12" *ngIf="tefAccounts.length > 0">
  <div class="card sales-summary rounded-10 shadow">
    <div class="card-header">
      <div class="card-title mb-0">{{ 'common.tefAccounts' | translate }}</div>
    </div>
    <div class="card-body">
      <div class="row g-3">
        <ng-container *ngFor="let tef of tefAccounts">
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <div class="input-icon-container">
                <input [value]="tef.description ? (tef.id + ' (' + tef.description + ')') : tef.id"
                       class="form-control"
                       readonly>
                <i class="fe fe-copy input-icon"
                   (click)="copyId(tef.id)"></i>
              </div>
            </div>
          </div>
        </ng-container>

        <div *ngIf="tefAccounts.length === 0" class="text-muted">
          {{ 'common.noData' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.transactionData' | translate }}</div>
      </div>
      <div class="card-body">
        <div class="alert alert-dark text-center" role="alert">
          <b
            >{{ 'common.availableBalance' | translate }}: 
            {{
              saldoDisponivel
                | formatCurrency
            }}</b
          >
        </div>
        <form [formGroup]="transferBalance">
          <div class="row">
            <div class="col-xl-7 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtNomeFavorecido" class="form-label">{{ 'common.account' | translate }} <span class="text-danger">*</span></label>
                <div class="input-icon-container">
                  <input class="form-control" [ngClass]="{'is-invalid state-invalid': transferBalance.controls.conta.invalid && isSubmitted}" [formControl]="transferBalance.controls.conta" type="text" name="nomeFavorecido" id="txtNomeFavorecido" [required]="true">
                  <i (click)="paste()" class="fe fe-copy input-icon"></i>
                </div>
                <div class="invalid-feedback">{{contaFeedBack}}</div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorSolicitado" class="form-label"
                  >{{ 'common.value' | translate }} <span class="text-danger">*</span></label
                >
                <input
                  [placeholder]="placeholderValue"
                  [formControl]="transferBalance.controls.valorSolicitado"
                  currencyMask
                  [options]="{ prefix: ('' | currencySymbol) + ' ' }"
                  class="form-control"
                  type="text"
                  name="valorSolicitado"
                  id="txtValorSolicitado"
                  (focusout)="valorSolicitadoChanged()"
                  [ngClass]="{
                    'is-invalid state-invalid':
                    transferBalance.controls.valorSolicitado.invalid && isSubmitted
                  }"
                />
                <div class="invalid-feedback">{{ valorFeedBack }}</div>
              </div>
            </div>
            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="openDataConfirm()"
              >
                <i class="fe fe-arrow-up-right"></i>{{ 'common.transferButton' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="openConfirm">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">Confirmar os dados</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-xl-6 col-lg-12 col-sm-12">
            <div class="form-group">
              <label for="txtNomeProprietario" class="form-label"
                >Pagador</label
              >
              <input
                [(ngModel)]="nomePagador"
                class="form-control"
                type="text"
                name="valorSolicitado"
                id="txtNomeProprietario"
                [readonly]="true"

              />
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="txtDocumentoRecebedor" class="form-label"
                >Recebedor
              </label>
              <input
                [(ngModel)]="nomeRecebedor"
                class="form-control"
                type="text"
                name="valorSolicitado"
                id="txtDocumentoRecebedor"
                [readonly]="true"
              />
            </div>
          </div>
          <div class="col-xl-1 col-lg-6 col-sm-6">
            <button
              type="button"
              class="our-button btn btn-pill btn-primary"
              (click)="makeFundTransfer()"
            >
              <i class="fe fe-arrow-up-right"></i>Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>
    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp()"
      />
      <button
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{'login.totp.pasteButton' | translate}}
      </button>
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
      [disabled]="validatingTotp">
      VALIDAR
    </button>
  </div>
</ng-template>
